//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//
import React from 'react';
import { useInRouterContext, useNavigate } from 'react-router-dom';

export const MEMBER_ACCESS_PATH = '/member-access';

interface MemberAccessLinkProps {
  children: React.ReactNode;
  /** Runs before navigating, e.g. to close the dialog the link sits in. */
  onNavigate?: () => void;
}

const RouterLink: React.FC<MemberAccessLinkProps> = ({
  children,
  onNavigate,
}) => {
  const navigate = useNavigate();
  return (
    <a
      href={MEMBER_ACCESS_PATH}
      className="underline"
      data-testid="member-access-link"
      onClick={(e) => {
        e.preventDefault();
        onNavigate?.();
        navigate(MEMBER_ACCESS_PATH);
      }}
    >
      {children}
    </a>
  );
};

/**
 * Link to the Member Access page.
 *
 * The app mounts its router with a basename, so a bare href would miss it; inside a router
 * we navigate client-side. Outside one (isolated renders) we fall back to a plain anchor
 * rather than throwing from useNavigate.
 */
const MemberAccessLink: React.FC<MemberAccessLinkProps> = (props) => {
  const inRouter = useInRouterContext();
  if (inRouter) {
    return <RouterLink {...props} />;
  }
  return (
    <a
      href={MEMBER_ACCESS_PATH}
      className="underline"
      data-testid="member-access-link"
      onClick={props.onNavigate}
    >
      {props.children}
    </a>
  );
};

export default MemberAccessLink;
